import React from 'react';
import cn from 'clsx';
import PropTypes from 'prop-types';

import styles from './fitment-tire-code-description.scss';

function FitmentTireCodeDescription(props) {
  const { className, isHighFloatation, isOpen, showDivider = false } = props;
  const cdn = 'https://cdn.discounttire.com/sys-master/images';
  const image = isHighFloatation
    ? `${cdn}/hcc/hf1/8888181751838/high-flotation-sidewall.jpg`
    : `${cdn}/h94/he7/8888181456926/p-metric-sidewall.jpg`;

  return (
    <div
      className={cn(
        showDivider ? styles['container-divider'] : styles['container'],
        isOpen && styles['container-open'],
        className
      )}
      data-testid="tire-description"
    >
      <div
        className={cn(
          styles['tire-code-description'],
          className ? `${className}__description` : null
        )}
      >
        <img alt="helpful tire size sidewall" src={image} />
        <p>
          Your tire sidewall has a series of numbers that show your specific
          tire and wheel size. Match the numbers from your tire to one of the
          size options below.
        </p>
      </div>
    </div>
  );
}

FitmentTireCodeDescription.propTypes = {
  className: PropTypes.string,
  isHighFloatation: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  showDivider: PropTypes.bool
};

export default FitmentTireCodeDescription;
